import useScrollAnimation from '../../../hooks/useScrollAnimation';

const HeroSection = () => {
  const { ref, animStyle } = useScrollAnimation(0.05);

  return (
    <section id="top" className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Cozy%20atmospheric%20Asian%20restaurant%20interior%20with%20warm%20amber%20candlelight%20rattan%20furniture%20dark%20wooden%20tables%20tropical%20plants%20turquoise%20accent%20walls%20resort%20lounge%20ambiance%20intimate%20dining%20space%20wide%20angle%20no%20people%20professional%20interior%20photography&width=1440&height=900&seq=hero1&orientation=landscape"
          alt="ASIAN KITCHEN BALEN 店内"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/55" />
      </div>

      {/* Content — pt-24 で固定ヘッダー（約80px）分の被りを回避 */}
      <div
        ref={ref}
        style={animStyle}
        className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-12 text-center pt-24 pb-10"
      >
        {/* Eyebrow */}
        <p className="font-sans-jp text-xs tracking-[0.35em] text-teal-light mb-6 uppercase">
          Asian Kitchen Balen &nbsp;—&nbsp; Kasugai, Aichi
        </p>

        {/* Main Headline */}
        <h1 className="font-serif-jp font-bold text-white mb-6">
          <span className="block text-2xl md:text-4xl lg:text-5xl tracking-wide leading-relaxed">
            スパイスとハーブが香る、
          </span>
          <span className="block text-2xl md:text-4xl lg:text-5xl tracking-wide leading-relaxed">
            アジアの家庭料理。
          </span>
          <span className="block text-lg md:text-2xl lg:text-3xl tracking-wide leading-relaxed mt-3 text-white/85">
            落ち着いた空間で、日常を忘れるひとときを。
          </span>
        </h1>

        {/* Divider */}
        <div className="flex items-center justify-center gap-4 my-7">
          <div className="h-px w-12 bg-teal-light/50" />
          <div className="w-1.5 h-1.5 rounded-full bg-orange-sunset" />
          <div className="h-px w-12 bg-teal-light/50" />
        </div>

        {/* Sub Copy */}
        <p className="font-sans-jp text-sm md:text-base text-white/75 leading-loose tracking-wider">
          ナシゴレン・ガパオライス・フォー等の定番料理
          <span className="mx-2 text-teal-light/50">/</span>
          カウンター・テーブル席あり
          <span className="mx-2 text-teal-light/50">/</span>
          駐車場完備
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
          <a
            href="#menu"
            onClick={(e) => { e.preventDefault(); document.querySelector('#menu')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="font-sans-jp text-sm tracking-widest px-8 py-3 bg-teal-deep text-white rounded-sm hover:bg-teal-mid transition-colors cursor-pointer whitespace-nowrap"
          >
            メニューを見る
          </a>
          <a
            href="#access"
            onClick={(e) => { e.preventDefault(); document.querySelector('#access')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="font-sans-jp text-sm tracking-widest px-8 py-3 border border-white/50 text-white rounded-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
          >
            アクセス・営業時間
          </a>
        </div>

        {/* Scroll indicator */}
        <div className="mt-14 flex flex-col items-center gap-2 text-white/45">
          <span className="font-sans-jp text-xs tracking-[0.4em]">SCROLL</span>
          <div className="w-px h-10 bg-gradient-to-b from-white/45 to-transparent animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
